import { useEffect, type ReactNode } from 'react'
import { IconButton } from './primitives'

/** Tiroir latéral (alertes). Ferme sur Échap et clic hors panneau. */
export function Drawer({
  open,
  title,
  onClose,
  children,
}: {
  open: boolean
  title: string
  onClose: () => void
  children: ReactNode
}) {
  useEffect(() => {
    if (!open) return
    const h = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', h)
    return () => document.removeEventListener('keydown', h)
  }, [open, onClose])

  if (!open) return null
  return (
    <>
      <div className="scrim" onClick={onClose} />
      <aside className="drawer" role="dialog" aria-label={title}>
        <div className="drawer__head">
          <h2 className="drawer__title">{title}</h2>
          <IconButton label="Fermer" icon="close" onClick={onClose} />
        </div>
        <div className="drawer__body">{children}</div>
      </aside>
    </>
  )
}
